export function iOS() {
  const expression = /(Mac|iPhone|iPod|iPad|iPad Simulator|iPhone Simulator)/i;
  return (
    expression.test(navigator.platform) ||
    (navigator?.userAgent?.includes("Mac") && "ontouchend" in document)
  );
}
